"use client";

import React from "react";

interface TickerItem {
  prefix?: string;
  highlight: string;
  suffix?: string;
  highlight2?: string;
  suffix2?: string;
}

interface CPAInfoProps {
  items: TickerItem[];
}

const InfoTicker = ({ items }: CPAInfoProps) => {
  const renderItems = () =>
    items.map((item, index) => (
      <React.Fragment key={index}>
        {index > 0 && <span className="text-white mx-6 text-xm">|</span>}
        <span className="text-white font-semibold">
          {item.prefix}
          <span className="text-[#FFBA08] font-semibold">{item.highlight}</span>
          {item.suffix}
          {item.highlight2 && (
            <span className="text-[#FFBA08] font-semibold">
              {item.highlight2}
            </span>
          )}
          {item.suffix2}
        </span>
      </React.Fragment>
    ));

  return (
    <>
      {/* mobile — hidden above md, shown below */}
      <div className="w-full hidden max-md:block">
        <div className="bg-gray-800 py-[10px] overflow-hidden">
          <p
            className="m-0 text-white text-base whitespace-nowrap overflow-visible font-semibold"
            style={{ animation: "cpaInfoMarquee 10s linear infinite" }}
          >
            {renderItems()}
          </p>
        </div>
        <style>{`
          @keyframes cpaInfoMarquee {
            0%   { transform: translateX(100%); }
            100% { transform: translateX(-130%); }
          }
        `}</style>
      </div>

      {/* desktop — shown above md, hidden below */}
      <div className="w-full block max-md:hidden">
        <div className="bg-gray-800 py-[10px] overflow-hidden">
          <p className="m-0 flex items-center justify-center text-sm font-semibold leading-[23px] text-white whitespace-nowrap overflow-visible indent-0">
            {renderItems()}
          </p>
        </div>
      </div>
    </>
  );
};

export default InfoTicker;
